var FreeShippingBar = class extends HTMLElement {
    static get observedAttributes() {
        return ["threshold", "steps", "total-price"];
    }
    constructor() {
        super();
        this._onCartChangedListener = this._onCartChanged.bind(this);
        this._currencyFormatter = new Intl.NumberFormat(Shopify.locale, { style: "currency", currency: Shopify.currency.active });
    }
    async connectedCallback() {
        document.addEventListener("cart:change", this._onCartChangedListener);
    }
    disconnectedCallback() {
        document.removeEventListener("cart:change", this._onCartChangedListener);
    }

    /**
     *  Si ricava gli steps passati nell'attributo steps del componente, mappandolo in un array
     *  con indici threshold, discount, type e position
     * @returns {*}
     */
    get steps() {

        const steps = JSON.parse(this.getAttribute("steps") || "[]")
            .map(step => ({
                threshold: parseFloat(step.target_carrello) * 100,
                discount: parseFloat(step.sconto) * 100,
                type: step.tipo_di_sconto[0]
            }))
            .sort((a,b)=>a.threshold-b.threshold)

        return steps.map((step, index) => ({
            ...step,
            position: index + 1
        }))

    }

    /**
     * Ricava la situazione corrente degli step con step raggiunto (reached) e successivo (next)
     * @returns {{reached: null, next: null}}
     * @private
     */
    _getStepStatus() {

        let reached = null
        let next = null

        if (this.totalPrice) {
            for (const step of this.steps) {

                if (this.totalPrice >= step.threshold) {
                    reached = step
                } else {
                    next = step
                    break
                }

            }
        }

        return { reached, next }

    }

    get totalPrice() {
        return parseFloat(this.getAttribute("total-price"));
    }
    set totalPrice(value) {
        this.setAttribute("total-price", value);
    }

    /**
     * Restituisce le traduzioni dai data attributes
     * @returns {object}
     */
    get translations() {
        return {
            all_unlocked: this.getAttribute("data-all-unlocked") || "Complimenti, hai sbloccato tutte le promozioni!",
            free_shipping_intro: this.getAttribute("data-free-shipping-intro") || "Complimenti, la spedizione è gratuita.",
            free_shipping_reward: this.getAttribute("data-free-shipping-reward") || "la spedizione gratuita.",
            discount_already_earned: this.getAttribute("data-discount-already-earned") || "Hai già uno sconto di",
            discount_reward: this.getAttribute("data-discount-reward") || "uno sconto di",
            additional_discount_reward: this.getAttribute("data-additional-discount-reward") || "un ulteriore sconto di",
            missing_amount_html: this.getAttribute("data-missing-amount-html") || 'Ti mancano solo <span class="bold text-accent">{{ price }}</span> per ottenere {{ reward }}'
        };
    }

    /**
     * Aggiorna il valore della progress bar per visualizzare l'avanzamento
     * L'avanzamento mostrato è sempre quelle relativo alla distanza di prezzo fra lo step raggiunto (o 0 se non c'è uno step raggiunto)
     * e lo step successivo
     * @private
     */
    _updateProgressBar(){

        const progressBar = this.querySelector("progress-bar")
        const { reached, next } = this._getStepStatus()

        const currentThreshold = reached ? reached.threshold : 0
        const nextThreshold = next ? next.threshold : this.totalPrice

        const range = nextThreshold - currentThreshold
        const progress = this.totalPrice - currentThreshold

        progressBar.valueMax = range
        progressBar.valueNow = progress

    }



    async attributeChangedCallback(attribute, oldValue, newValue) {
        await window.customElements.whenDefined("progress-bar");
        const progressBarElement = this.querySelector("progress-bar");
        switch (attribute) {
            case "total-price":
                progressBarElement.valueNow = newValue;
                this._updateProgressBar()
                break;
        }
        this._updateMessage();
    }

    /**
     * Aggiorna il messaggio visualizzato sopra la progress bar
     * @private
     */
    _updateMessage() {

        const t = this.translations;
        const messageElement = this.querySelector("span")
        const { reached, next } = this._getStepStatus()

        if (!reached && !next) {
            return
        }

        if (!next) {
            messageElement.innerHTML = t.all_unlocked
            return
        }

        const remaining = next.threshold - this.totalPrice
        const price = this._currencyFormatter.format(remaining / 100);
        let rewardText = ""
        let rewardTextIntro = "";

        if (next.type === "Spedizione gratuita") {
            rewardText = t.free_shipping_reward
        }

        if (next.type === "Importo fisso") {

            const discount = this._currencyFormatter.format(next.discount / 100)
            const discountReached = this._currencyFormatter.format(reached.discount / 100)

            rewardText = `${t.discount_reward} ${discount}`;
            rewardTextIntro = t.free_shipping_intro;
            if (reached.position >= 2) {
                rewardTextIntro = rewardTextIntro + ` ${t.discount_already_earned} ${discountReached}. `;
                rewardText = `${t.additional_discount_reward} ${discount}`;
            }

        }

        // Usa il template HTML dalle traduzioni
        const template = t.missing_amount_html;
        messageElement.innerHTML = rewardTextIntro + " " + template
            .replace('{{ price }}', price)
            .replace('{{ reward }}', rewardText);

    }

    _onCartChanged(event) {
        // Soglie step calcolate sul subtotale lordo degli articoli spedibili (pre-sconto carrello).
        const priceForItems = event.detail["cart"]["items"].filter((item) => item["requires_shipping"]).reduce((sum, item) => sum + item["final_line_price"], 0);
        this.totalPrice = priceForItems;
    }
};
if (!window.customElements.get("free-shipping-bar")) {
    window.customElements.define("free-shipping-bar", FreeShippingBar);
}

// override del _checkTransparency originale solo per evitare l'aggiunta della classe is-filled all'open della sezione lingua nell'header
(function () {
    const originalDefine = customElements.define;

    customElements.define = function (name, constructor, options) {

        if (name === "store-header") {

            const originalMethod = constructor.prototype._checkTransparency;

            constructor.prototype._checkTransparency = function () {

                let hasFallbackScrollDetection = false;
                if (CSS.supports("selector(:has(> *))") && this.hasAttribute("sticky") && !this.hasAttribute("hide-on-scroll") && this.hasAttribute("allow-transparency")) {
                    const offsetBeforeChanging = 500;
                    if (this.querySelectorAll("[open]").length > 0) {
                        // this.classList.add("is-filled");
                    } else if (window.scrollY >= offsetBeforeChanging && !this._hasSwitchedToSticky) {
                        this._hasSwitchedToSticky = true;
                        this.classList.add("is-filled");
                        animate11(this, { transform: ["translateY(-100%)", "translateY(0)"] }, { duration: 0.15, easing: "ease" });
                    } else if (window.scrollY < offsetBeforeChanging) {
                        if (this._hasSwitchedToSticky) {
                            this._hasSwitchedToSticky = false;
                            animate11(this, { transform: ["translateY(0)", "translateY(-100%)"] }, { duration: 0.15, easing: "ease" }).finished.then(() => {
                                this.style.transform = null;
                                this.classList.remove("is-filled");
                            });
                        } else if (this.getAnimations().length === 0) {
                            this.classList.remove("is-filled");

                        }
                    }
                } else {
                    hasFallbackScrollDetection = this.hasAttribute("sticky") && window.scrollY > 20;
                    this.classList.toggle("is-filled", !this.hasAttribute("allow-transparency") || this.querySelectorAll("[open]").length > 0 || hasFallbackScrollDetection);
                }
            };
        }

        return originalDefine.call(this, name, constructor, options);
    };
})();

// override di openZoom: selettore aggiornato per supportare figure come padre di img
(function () {
    const originalDefine = customElements.define;

    customElements.define = function (name, constructor, options) {

        if (name === "product-gallery") {
            constructor.prototype.openZoom = function (index = 0) {
                const dataSource = Array.from(
                    this.querySelectorAll('.product-gallery__media[data-media-type="image"]:not([hidden]) img')
                ).map((image) => ({
                    thumbnailElement: image,
                    src: image.src,
                    srcset: image.srcset,
                    msrc: image.currentSrc || image.src,
                    width: parseInt(image.getAttribute("width")),
                    height: parseInt(image.getAttribute("height")),
                    alt: image.alt,
                    thumbCropped: true
                }));
                this.photoswipe.loadAndOpen(index, dataSource);
            };
        }

        return originalDefine.call(this, name, constructor, options);
    };
})();
/* ===========================================================================


/* ===========================================================================
   CARRELLO USA/FR — i cinque punti del ticket Shopify (Felicia, 31/08/2026)
   ===========================================================================
   DOVE VA: in coda a `assets/mf-custom.js` del tema.
   ⚠️ E CONTESTUALMENTE VA RIMOSSO il vecchio <script> `__mfCartDrawerGuard` in
   fondo a `sections/mf-cart-drawer.liquid` (quello del 28/08): la rete adesso
   vive qui, agganciata all'evento invece che a `fetch`. Lasciare anche il
   vecchio significa tenere due controlli di cui uno finto — non fa danno, ma
   dice il falso a chi legge, ed e' esattamente l'equivoco che ci e' costato
   tre giorni.
 NON in theme.js: quello e'
   il bundle del tema Impact (182 KB minificati) e ogni aggiornamento del tema o
   rideploy dell'agenzia lo sovrascrive, portandosi via le correzioni in
   silenzio. `mf-custom.js` e' nostro, e' caricato PRIMA di theme.js (verificato)
   e sopravvive.

   I PUNTI DEL TICKET, e come sono affrontati qui:

   1. theme.js:1807 — «l'aggiornamento della finestra si affida all'HTML della
      sezione senza validazione o fallback: quando e' vuoto, il conteggio si
      aggiorna e la finestra resta vuota».
      → La validazione NON si mette dentro il tema (i suoi metodi cambiano con
        gli aggiornamenti) ma nel TRASPORTO: si intercetta la risposta delle
        chiamate al carrello e, se l'HTML della sezione manca o non contiene le
        righe, lo si sostituisce con quello vero preso da `?section_id=`. Il
        tema riceve sempre dati sani e non deve sapere niente.
      È il guasto vero visto il 28/08: `sections: null` sul mercato USA, con
      HTTP 200 e carrello aggiornato (x-request-id 70dad5bc-…-1787936303).

   2. theme.js:1814 — «ritardo di 1,25s senza meccanismo per annullare gli
      aggiornamenti precedenti: operazioni rapide sovrascrivono lo stato piu'
      recente con dati piu' vecchi».
      → Il timer vive dentro il tema e non e' raggiungibile. Invece di
        annullarlo si rende INNOCUO: a ogni chiamata al carrello si incrementa
        un contatore, e la risposta che arriva quando ne e' partita un'altra
        dopo viene servita con l'HTML dell'ULTIMO stato. Il tema può scrivere in
        ritardo quanto vuole: scrivera' comunque la cosa giusta.

   3. theme.js:2820 — «un risultato aggiornato di /cart.js combinato con l'HTML
      della sezione di una risposta precedente: due istantanee diverse».
      → Stesso rimedio del punto 2: l'HTML che consegniamo e' sempre coerente
        con lo stato del momento, quindi le due istantanee combaciano.

   4. mf-pixel-trackings.liquid:218 — campi `items_removed`/`items_added`
      inesistenti, errori JS a ogni interazione.
      → GIA' RISOLTO il 28/08/2026 (guardie sui due campi). Qui non si tocca.

   5. theme.js:2032 — «il gestore del clic per la rimozione usa un controllo del
      target fragile che fallisce silenziosamente a meno che l'elemento cliccato
      non sia esattamente il tag <a>».
      → Si avvolge `_onRemoveLinkClicked` e si corregge il bersaglio quando il
        clic arriva su un figlio del link (l'icona, il testo). La logica del
        tema non si riscrive: si normalizza cio' che riceve.

   ⚠️ INTERRUTTORE: `ATTIVO = false` spegne tutto il pacchetto in un minuto,
   senza rimuovere codice. Se il carrello facesse qualcosa di strano dopo il
   rilascio, si spegne prima e si capisce dopo.

   ⚠️ PERCHE' LA PRIMA VERSIONE NON FACEVA NIENTE (31/08/2026, misurato in
   produzione dopo l'incollaggio): `window.fetch` in pagina non era ne' nativo
   ne' nostro. Un'app di terze parti lo aveva SOSTITUITO dopo di noi, catturando
   il nativo e lasciando il nostro wrapper orfano: le chiamate al carrello non
   passavano piu' da qui. Nessun errore, nessun sintomo — semplicemente il
   rimedio non vedeva nulla. La stessa cosa spiega perche' la rete di protezione
   del 28/08 risultava installata (`__mfCartDrawerGuard` a true) e non
   interveniva mai.
   → Ora il wrapper si RIPRENDE il posto: vedi `riprendi()` piu' sotto. Lezione
   generale per questo tema: qualunque cosa si agganci a un oggetto globale
   (fetch, XMLHttpRequest, customElements) va verificata DOPO, in pagina, non
   solo al momento in cui la si installa.

   ✅ PROVATO IN PRODUZIONE (31/08/2026, dopo l'ultima correzione):
   - con la modalita' di prova accesa: diario «provo a riparare» ×7 →
     «RIPARATO» ×7, e l'HTML consegnato al tema e' quello fresco (12.317
     caratteri, con le righe dentro). Il ripiego funziona.
   - a prova spenta: «niente da fare: html buono» dove non serve, e 4
     riparazioni tutte per «risposta superata» — con il contatore che arriva a 3
     e a 6 per UNA sola modifica: sulla pagina scrivono anche le app, e le loro
     risposte in ritardo avrebbero sovrascritto il pannello. E' il punto 2-3 del
     ticket, in azione.
   - le chiamate `add.js` e `clear.js` escono con «la chiamata non chiedeva
     sezioni»: giusto, quel percorso non passa dalla sezione.

   ⚠️ COSTO NOTO, RISOLTO: ogni risposta superata costava una richiesta
   `?section_id=` (nella prova, 4 su 6). Ora c'e' la memoria di 300 ms
   (`CACHE_MS`, piu' sotto): le risposte superate nello stesso istante
   condividono una sola richiesta, e chi arriva mentre e' in volo si mette in
   fila su quella. Il commento precedente diceva «non fatto»: era rimasto
   indietro rispetto al codice.

   ⚠️ STATO DELLA PROVA (storico) — com'era prima della correzione.
   La sintassi e' valida (eseguito in pagina senza errori) e il codice NON
   interviene quando non serve. Ma il ripiego **non e' stato visto scattare**:
   tre banchi di prova sono falliti per motivi loro, non del rimedio —
   (a) un guastatore che simulava `sections: null` non intercettava, perche'
   i wrapper accumulati sulla pagina di prova si scavalcavano a vicenda;
   (b) l'aggiunta dalla scheda prodotto NON chiede le sezioni (misurato: 1
   `add.js` + 9 `cart.js`, zero `?section_id=`), quindi non passa da qui;
   (c) i clic simulati sul «+» del pannello non innescavano la chiamata.
   → La prova si fa in 30 secondi in produzione, con la MODALITA' DI PROVA qui
   sotto. Finche' non e' fatta, questo file e' un rimedio ragionato, non
   collaudato.

   ⚠️ COSA COPRE DAVVERO. Il tema chiede l'HTML della sezione sulle chiamate
   `change.js` (verificato: `{"id":…,"quantity":N,"sections":[…]}`) e li' il
   ripiego vale. Sull'AGGIUNTA il tema non lo chiede affatto: quindi il sintomo
   «la finestra non si aggiorna dopo l'aggiunta» descritto dal ticket passa da
   un'altra strada, ancora da capire. Non promettere che questo file lo copra.
   =========================================================================== */
(function () {
  'use strict';

  var ATTIVO = true;

  // MODALITA' DI PROVA. Il guasto vero (`sections: null`) capita quando capita:
  // il 28/08 e' durato quattro ore e non si riproduce a comando — provare a
  // simularlo dal browser sovrapponendo wrapper a `fetch` non ha funzionato in
  // modo affidabile (31/08). Senza una prova, questo rimedio sarebbe una
  // guardia non collaudata, e di quelle ne abbiamo gia' pagate.
  // Quindi: da console, `window.__mfCartFixProva = true` fa considerare
  // SEMPRE inservibile l'HTML che arriva, cosi' il ripiego scatta a ogni
  // modifica del carrello e si vede se ricompone il pannello per davvero.
  // Va spenta dopo (`= false`), e in ogni caso muore con la pagina.
  function inProva() { return window.__mfCartFixProva === true; }

  // Solo i mercati dove il guasto e' stato osservato e segnalato. Il mercato
  // italiano non e' mai stato colpito: tenerlo fuori riduce la superficie.
  //
  // ⚠️ COSA COPRE E COSA NO — verificato il 31/08/2026, perche' per mezza
  // giornata questo commento ha detto il falso. Il cancello vale per:
  //   - il livello di RETE (punti 1-2-3): fuori perimetro la chiamata passa
  //     intatta, non la guardiamo nemmeno;
  //   - la SORVEGLIANZA DELL'APERTURA: fuori perimetro non si installa
  //     l'osservatore e non si fa la richiesta a `cart.js`. Prima era globale:
  //     una richiesta in piu' per ogni apertura del pannello su OGNI paese,
  //     Italia compresa, mentre qui sopra c'era scritto il contrario.
  // NON vale invece per il punto 5 (clic di rimozione), ed e' voluto: quel
  // difetto del tema c'e' su tutti i mercati, la correzione non fa richieste e
  // non costa niente. Resta globale di proposito.
  var MERCATI = ['/en-us/', '/es-us/', '/fr-fr/'];

  var SCRITTURE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  if (!ATTIVO || !window.fetch) { return; }

  function radice() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function nostroMercato() {
    var r = radice();
    for (var i = 0; i < MERCATI.length; i++) {
      if (r === MERCATI[i]) { return true; }
    }
    return false;
  }

  // L'id della sezione del pannello si LEGGE dalla pagina, non si scrive qui:
  // cambia a ogni rigenerazione del tema (28/08: sections--24467464913223__…,
  // 31/08: sections--27197304701255__…). Un id cablato avrebbe funzionato per
  // una settimana.
  function idSezionePannello() {
    var d = document.getElementById('cart-drawer');
    var s = d && d.closest ? d.closest('[id^="shopify-section-"]') : null;
    return s ? s.id.replace('shopify-section-', '') : null;
  }

  // Un HTML di sezione e' buono se contiene il pannello E il posto delle righe.
  // Non basta "non vuoto": il 28/08 arrivava proprio una risposta valida come
  // JSON con il campo a null.
  function htmlBuono(html) {
    if (inProva()) { return false; }        // vedi MODALITA' DI PROVA
    if (!html || typeof html !== 'string' || html.length < 200) { return false; }
    return html.indexOf('cart-drawer') !== -1 &&
           (html.indexOf('cart-drawer__line-items') !== -1 ||
            html.indexOf('empty-state') !== -1);
  }

  // Cache brevissima sulla richiesta della sezione. Serve perche' su una sola
  // modifica del carrello partono PIU' scritture in parallelo (misurato il
  // 31/08: il contatore arriva a 3 e a 6 per un solo clic — scrivono anche le
  // app), e ognuna che rientra superata chiederebbe la sua copia della sezione:
  // 4 richieste su 6 chiamate. Con 300 ms di memoria le risposte che arrivano
  // insieme condividono una sola richiesta, e chi arriva mentre e' in volo si
  // mette in attesa della stessa promessa invece di aprirne un'altra.
  var CACHE_MS = 300;
  var cache = { html: null, quando: 0, inVolo: null };

  function chiediSezione(id) {
    var ora = Date.now();
    if (cache.html && (ora - cache.quando) < CACHE_MS) {
      nota('sezione dalla memoria breve');
      return Promise.resolve(cache.html);
    }
    if (cache.inVolo) { return cache.inVolo; }
    cache.inVolo = fetchOriginale(radice() + '?section_id=' + encodeURIComponent(id),
                                  { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        cache.html = html;
        cache.quando = Date.now();
        cache.inVolo = null;
        return html;
      })
      .catch(function () {
        cache.inVolo = null;
        return null;
      });
    return cache.inVolo;
  }

  // Conteggio: quando il ripiego scatta, lo diciamo a GA4. Serve a rispondere
  // con i numeri alla domanda «capita sui picchi di traffico?»: il 28/08 il
  // picco USA (513 sessioni/ora) era un'ora e mezza PRIMA del guasto, e con due
  // soli x-request-id non si dimostra niente.
  function segnala(motivo, url) {
    try {
      var dati = {
        event: 'cart_section_repair',
        cart_repair_reason: motivo,
        cart_repair_path: String(url || '').split('?')[0],
        cart_repair_market: radice()
      };
      if (window.dataLayer && window.dataLayer.push) { window.dataLayer.push(dati); }
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'cart_section_repair', dati);
      }
      // resta anche in console: se GA4 non ricevesse, la prova non si perde
      if (window.console && console.warn) {
        console.warn('[mf] sezione carrello riparata:', motivo, dati.cart_repair_path);
      }
    } catch (e) { /* un contatore non deve mai rompere un carrello */ }
  }

  // ⚠️ IL WRAPPER VA DIFESO. Un'app di terze parti puo' SOSTITUIRE
  // `window.fetch` dopo di noi catturando il fetch nativo, e allora il nostro
  // wrapper resta orfano: le chiamate al carrello non passano piu' da qui e il
  // rimedio non fa niente, in silenzio. Misurato il 31/08/2026 su una scheda
  // USA: `window.fetch` non era ne' nativo ne' nostro — e la stessa cosa
  // spiega perche' la rete di protezione del 28/08 risultava installata e non
  // interveniva mai.
  //
  // Quindi ce lo riprendiamo: un controllo leggero verifica che il wrapper sia
  // ancora al suo posto e, se qualcuno l'ha scavalcato, riavvolge il fetch
  // corrente (la catena diventa noi → loro → nativo). Il controllo si dirada e
  // si spegne da solo: non e' un guardiano perenne, e' il tempo che serve alle
  // app per finire di caricarsi.
  // ⚠️ La VERSIONE nel marcatore non e' un vezzo. Fino al 01/09/2026 diceva solo
  // 'attivo', identico in ogni copia: dal browser era impossibile distinguere la
  // versione appena incollata da quella di ieri rimasta in cache — e l'equivoco
  // ci e' costato due giri. Chi tocca questo file **alza la data**.
  window.__mfCartFix = 'attivo — 2026-09-01 (perimetro + chiavi aggiunta)';

  // DIARIO DIAGNOSTICO. Il 31/08/2026 il rimedio risultava in linea, il wrapper
  // era nostro, le chiamate ci passavano — e non entrava mai nella riparazione.
  // Quattro ipotesi verificate e cadute dall'esterno senza capire dove uscisse:
  // dedurre il punto di uscita guardando da fuori e' costato piu' del metterlo
  // per iscritto. Ogni passaggio scrive qui la ragione per cui e' finito.
  // Si legge da console: `window.__mfCartFixDiario`.
  window.__mfCartFixDiario = [];
  function nota(cosa, extra) {
    try {
      var d = window.__mfCartFixDiario;
      d.push({quando: new Date().toISOString().slice(11, 23), esito: cosa,
              dettaglio: extra === undefined ? null : extra});
      if (d.length > 40) { d.shift(); }
    } catch (e) { /* la diagnostica non deve mai rompere niente */ }
  }

  var giro = 0;            // cresce a ogni scrittura sul carrello

  function costruisci(precedente) {
    var nostro = function (risorsa, opzioni) {
      var url = '';
      try {
        url = (typeof risorsa === 'string') ? risorsa : ((risorsa && risorsa.url) || '');
      } catch (e) { url = ''; }

      if (!url || !SCRITTURE.test(url) || !nostroMercato()) {
        if (url && /\/cart\//.test(url)) {
          nota('fuori perimetro', {url: url.slice(0, 60),
               scrittura: SCRITTURE.test(url), mercato: nostroMercato(), radice: radice()});
        }
        return precedente(risorsa, opzioni);
      }

      var mio = ++giro;
      return precedente(risorsa, opzioni).then(function (risposta) {
        // Non si tocca una risposta in errore: deve restare l'errore che e',
        // per non nascondere guasti veri.
        //
        // ⚠️ NON si filtra sul tipo dichiarato. La prima versione pretendeva
        // 'json' nel content-type e scartava TUTTO: le route .js del carrello
        // Shopify rispondono `text/javascript`, non `application/json`.
        // Misurato il 31/08/2026 col diario: 9 chiamate su 9 uscivano qui, con
        // risposta ok e tipo senza 'json'. Il rimedio non ha mai lavorato per
        // una riga di prudenza sbagliata — e da fuori sembrava tutto in ordine.
        // Se il corpo non e' JSON lo dice il parse, che e' gia' protetto.
        if (!risposta.ok) {
          nota('risposta in errore', {ok: false});
          return risposta;
        }

        return risposta.clone().json().then(function (dati) {
          var id = idSezionePannello();
          if (!id) { nota('sezione del pannello non trovata'); return risposta; }

          var sezioni = dati && dati.sections;
          var html = sezioni && typeof sezioni === 'object' ? sezioni[id] : null;
          var sorpassato = mio !== giro;      // ne e' partita un'altra dopo

          // Si interviene in due casi: HTML inservibile (punto 1), oppure
          // risposta superata da una piu' recente (punti 2 e 3).
          if (htmlBuono(html) && !sorpassato) {
            nota('niente da fare: html buono', {caratteri: html ? html.length : 0});
            return risposta;
          }
          if (!sezioni && !sorpassato) {
            // Le chiavi servono: il percorso di AGGIUNTA chiede la sezione del
            // pannello dentro il corpo del POST (`sections` nel FormData, vedi
            // theme.js:2819-2824), non con `?section_id=`. Quindi qui le
            // sezioni dovrebbero esserci, e nella prova del 31/08 non c'erano.
            // Senza sapere COSA e' arrivato si torna a dedurre da fuori, che su
            // questo carrello e' costato tre giorni.
            nota('la chiamata non chiedeva sezioni',
                 {chiavi: dati ? Object.keys(dati).join(',') : '(corpo vuoto)',
                  url: url.slice(0, 60)});
            return risposta;
          }
          nota('provo a riparare', {motivo: sorpassato ? 'risposta superata' : 'html mancante',
               prova: inProva(), giro: mio, ultimo: giro});

          return chiediSezione(id).then(function (fresco) {
            if (!fresco || (!htmlBuono(fresco) && !inProva())) {
              nota('sezione fresca inservibile', {caratteri: fresco ? fresco.length : 0});
              return risposta;
            }
            var nuovoCorpo = {};
            for (var k in dati) {
              if (Object.prototype.hasOwnProperty.call(dati, k)) { nuovoCorpo[k] = dati[k]; }
            }
            nuovoCorpo.sections = {};
            if (sezioni && typeof sezioni === 'object') {
              for (var sz in sezioni) {
                if (Object.prototype.hasOwnProperty.call(sezioni, sz)) {
                  nuovoCorpo.sections[sz] = sezioni[sz];
                }
              }
            }
            nuovoCorpo.sections[id] = fresco;
            nota('RIPARATO', {caratteri: fresco.length});
            segnala(sorpassato ? 'risposta superata' : 'html mancante', url);
            return new Response(JSON.stringify(nuovoCorpo), {
              status: risposta.status,
              statusText: risposta.statusText,
              headers: { 'Content-Type': 'application/json' }
            });
          });
        }).catch(function (e) {
          nota('errore durante la riparazione', String(e && e.name));
          return risposta;
        });
      });
    };
    nostro.__mfNostro = true;
    return nostro;
  }

  // `fetchOriginale` serve a chiedere la sezione fresca: si tiene il fetch piu'
  // vicino al nativo che abbiamo visto, per non rientrare nel nostro wrapper.
  var fetchOriginale = window.fetch.bind(window);

  function riprendi() {
    try {
      if (!window.fetch || window.fetch.__mfNostro) { return false; }
      window.fetch = costruisci(window.fetch.bind(window));
      return true;
    } catch (e) { return false; }
  }

  riprendi();

  // Le app finiscono di caricarsi nei primi secondi: si controlla spesso
  // all'inizio, poi piu' rado, poi si smette. Un timer perenne su ogni pagina
  // sarebbe un costo senza motivo.
  var controlli = 0;
  var vigile = setInterval(function () {
    controlli += 1;
    if (riprendi() && window.console && console.warn) {
      console.warn('[mf] wrapper del carrello ripreso dopo essere stato scavalcato');
    }
    if (controlli >= 20) { clearInterval(vigile); }
  }, 1000);


  // ── LA RETE DI PROTEZIONE, ORA AGGANCIATA ALL'EVENTO ────────────────────
  // Il rimedio qui sopra lavora sul TRASPORTO: copre le chiamate dove il tema
  // chiede la sezione (change/update). Ma sull'AGGIUNTA il tema non la chiede
  // affatto — misurato il 31/08/2026: un `add.js` e nove `cart.js`, zero
  // `?section_id=` — quindi lì non c'e' niente da validare al volo e serve un
  // controllo a valle: guardare il pannello e, se diverge dal carrello vero,
  // ricomporlo.
  //
  // ⚠️ QUESTA RETE ESISTEVA GIA' dal 28/08, dentro `sections/mf-cart-drawer.liquid`,
  // e non e' MAI intervenuta: si agganciava a `fetch`, e un'app lo sostituiva
  // dopo di lei. Installata, dichiarata, inerte — per tre giorni abbiamo creduto
  // di avere una rete che non c'era. Ora ascolta l'evento `cart:change` del
  // tema, che nessuno puo' rimpiazzare, e vive in questo file insieme al resto.
  //   → il vecchio <script> in mf-cart-drawer.liquid VA RIMOSSO: lasciarlo
  //     significa tenere due controlli di cui uno finto.
  var ATTESA_MS = 1600;        // il tema rende le righe con 1,25s di ritardo
  var attesa = null;
  var giaInCorso = false;

  document.addEventListener('cart:change', function (evento) {
    var carrello = evento && evento.detail ? evento.detail.cart : null;
    // Un solo controllo per raffica: le modifiche rapide non si accodano, e
    // vince sempre l'ultimo stato.
    clearTimeout(attesa);
    attesa = setTimeout(function () { controlla(carrello); }, ATTESA_MS);
  });

  function controlla(carrello) {
    var pannello = document.getElementById('cart-drawer');
    if (!pannello || giaInCorso) { return; }
    var atteso = carrello && typeof carrello.item_count === 'number'
      ? carrello.item_count : null;
    if (atteso === null) { return; }          // senza il numero vero non si giudica

    var badge = pannello.querySelector('cart-count');
    var mostrato = badge ? parseInt((badge.textContent || '').trim(), 10) : NaN;
    var righe = pannello.querySelectorAll('.cart-drawer__line-items > *').length;
    var vuoto = !!pannello.querySelector('.empty-state');

    var divergono = (atteso === 0 && !vuoto) ||
                    (atteso > 0 && (vuoto || righe === 0 || mostrato !== atteso));
    if (!divergono) { nota('rete: pannello allineato'); return; }

    nota('rete: pannello divergente, ricompongo',
         {atteso: atteso, mostrato: isNaN(mostrato) ? null : mostrato, righe: righe});
    ricomponi();
  }

  function ricomponi() {
    var id = idSezionePannello();
    var pannello = document.getElementById('cart-drawer');
    if (!id || !pannello) { return; }
    giaInCorso = true;
    chiediSezione(id).then(function (html) {
      try {
        if (!htmlBuono(html) && !inProva()) { nota('rete: sezione inservibile'); return; }
        var fresco = new DOMParser().parseFromString(html, 'text/html')
          .getElementById('cart-drawer');
        if (!fresco) { nota('rete: pannello non trovato nella sezione'); return; }
        pannello.innerHTML = fresco.innerHTML;
        nota('rete: RICOMPOSTO');
        segnala('rete a valle', location.pathname);
      } finally { giaInCorso = false; }
    }).catch(function () { giaInCorso = false; });
  }

  // ── E CHI APRE IL PANNELLO VEDE SEMPRE LO STATO VERO ────────────────────
  // La rete qui sopra ascolta `cart:change`, che il tema emette quando e' LUI a
  // modificare il carrello. Ma il carrello puo' cambiare per altre vie — un'app
  // che scrive senza emettere l'evento, un'altra scheda aperta, il ritorno
  // indietro del browser — e allora il pannello resta indietro e nessuno lo sa.
  // Misurato il 31/08/2026: modificando il carrello con chiamate dirette, il
  // pannello ha continuato a mostrare 1 articolo su 4.
  //
  // Il momento in cui questo conta e' uno solo: quando il cliente APRE il
  // pannello. Li' si guarda il carrello vero e, se diverge, si ricompone prima
  // che lo veda. Si ascolta l'ATTRIBUTO `open` del pannello, non un metodo del
  // tema: i metodi cambiano con gli aggiornamenti, l'attributo no.
  // ✅ PROVATO IN PRODUZIONE (31/08/2026): carrello portato a 3 articoli con
  // chiamate dirette (nessun evento), pannello rimasto a 1. Aperto il pannello:
  // «apertura pannello: controllo» → «divergente, ricompongo» → «RICOMPOSTO»,
  // e il pannello e' passato a 3 articoli / $204.12, uguale al carrello vero.
  var ultimaApertura = 0;
  var PAUSA_APERTURA_MS = 1500;      // niente raffiche se il pannello sfarfalla

  function alApriPannello() {
    if (!nostroMercato()) { return; }   // fuori perimetro: nessuna richiesta
    var ora = Date.now();
    if (ora - ultimaApertura < PAUSA_APERTURA_MS) { return; }
    ultimaApertura = ora;
    // Qui l'evento non c'e', quindi il carrello vero si chiede: una richiesta
    // leggera e solo all'apertura, non a ogni modifica.
    fetchOriginale(radice() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (carrello) {
        if (!carrello) { return; }
        nota('apertura pannello: controllo');
        controlla(carrello);
      })
      .catch(function () { /* senza il carrello vero non si giudica */ });
  }

  function sorvegliaApertura() {
    if (!nostroMercato()) { return; }   // fuori perimetro: nessun osservatore
    var pannello = document.getElementById('cart-drawer');
    if (!pannello || pannello.__mfSorvegliato) { return; }
    pannello.__mfSorvegliato = true;
    if (pannello.hasAttribute('open')) { alApriPannello(); }
    try {
      new MutationObserver(function (mutazioni) {
        for (var i = 0; i < mutazioni.length; i++) {
          if (mutazioni[i].attributeName === 'open' && pannello.hasAttribute('open')) {
            alApriPannello();
            return;
          }
        }
      }).observe(pannello, { attributes: true, attributeFilter: ['open'] });
    } catch (e) { /* senza sorveglianza restano gli altri due livelli */ }
  }

  // Il pannello puo' non esserci ancora quando questo file gira, e puo' essere
  // rifatto dal tema: si riprova per i primi secondi, come per il wrapper.
  sorvegliaApertura();
  var tentativiPannello = 0;
  var cercaPannello = setInterval(function () {
    sorvegliaApertura();
    if (++tentativiPannello >= 20) { clearInterval(cercaPannello); }
  }, 1000);

  // -- punto 5: il clic di rimozione ----------------------------------------
  // Il tema controlla che l'elemento cliccato sia il tag <a>. Nel pannello il
  // link contiene testo (e su altri temi un'icona): cliccando dentro, il
  // controllo fallisce e non succede NIENTE — nessun errore, nessuna rimozione.
  // Qui si corregge il bersaglio e si passa la palla all'originale.
  //
  // ⚠️ NON si intercetta `customElements.define`. La prima versione lo faceva —
  // e' il pattern usato altrove in questo file per header e galleria — ma
  // avvolgere `define` mette il nostro codice nella catena di registrazione di
  // OGNI componente del tema: il 31/08/2026 uno stack di errore del mega menu
  // (`MegaMenuPromoCarousel.connectedCallback`, un guasto che non c'entra col
  // carrello) mostrava tre livelli di `mf-custom.js` e non si capiva piu' di chi
  // fosse la colpa. Con `whenDefined` restiamo fuori da qualunque stack che non
  // sia il nostro, e un errore del tema resta leggibile come errore del tema.
  if (customElements && customElements.whenDefined) {
    customElements.whenDefined('line-item-quantity').then(function (Classe) {
      try {
        var C = Classe || customElements.get('line-item-quantity');
        if (!C || !C.prototype || !C.prototype._onRemoveLinkClicked) { return; }
        var originale = C.prototype._onRemoveLinkClicked;
        if (originale.__mfAvvolto) { return; }          // mai due volte
        var avvolto = function (evento) {
          try {
            var t = evento && evento.target;
            var a = t && t.closest ? t.closest('a[href]') : null;
            if (a && t !== a) {
              Object.defineProperty(evento, 'target', { value: a, configurable: true });
            }
          } catch (e) { /* se non riesco, l'originale si comporta come prima */ }
          return originale.call(this, evento);
        };
        avvolto.__mfAvvolto = true;
        C.prototype._onRemoveLinkClicked = avvolto;
      } catch (e) { /* mai rompere un componente del tema */ }
    }).catch(function () { /* componente mai definito: niente da fare */ });
  }
})();
